import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAe4jzDu2PukTAO_MypVLtNUz4oAHrAHLY",
  authDomain: "clothing-store-51668.firebaseapp.com",
  projectId: "clothing-store-51668",
  storageBucket: "clothing-store-51668.appspot.com",
  messagingSenderId: "880599078257",
  appId: "1:880599078257:web:71f46fca305bae3cb4d2d0",
  measurementId: "G-K28NEHRS54"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
